module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedLight.24f5147.eot";